import React from 'react';
import Image from 'next/image';

import { ISocialProofFields } from '../../../types/contentful';

import { ScrollReveal } from '../ScrollReveal';
import RichText from '../RichText';

export function SocialProof({
  bodyCopy,
  headingText,
  fullStar,
  partialStar
}: ISocialProofFields) {
  const { file, description } = fullStar?.fields ?? {};
  const { file: psFile, description: psDescription } =
    partialStar?.fields ?? {};

  return (
    <div
      className="social-proof-container"
      data-blockid="socialProofContainer"
      data-testid="socialProofContainer"
    >
      <ScrollReveal className="block-container mb-12 mt-12 tablet:mb-16 [&>*]:px-3 tablet:[&>*]:px-12">
        <div
          id="socialProof"
          data-blockid="socialProof"
          className="flex min-w-0 flex-1 shrink-0 basis-full"
        >
          <div className="social-proof-card">
            <div className="social-proof-card-layout">
              <div className="column flex w-10/12 flex-col">
                <div className="m-auto">
                  {file?.url && (
                    <>
                      <Image
                        src={`https:${file.url}`}
                        alt={description ?? 'Star for Greenlight rating'}
                        width={45}
                        height={45}
                        sizes="(min-width: 720px) 45px, 35px"
                        className="m-1 inline-block w-[2.1875rem] tablet:m-2 tablet:w-[2.8125rem]"
                      />
                      <Image
                        src={`https:${file.url}`}
                        alt={description ?? 'Star for Greenlight rating'}
                        width={45}
                        height={45}
                        sizes="(min-width: 720px) 45px, 35px"
                        className="m-1 inline-block w-[2.1875rem] tablet:m-2 tablet:w-[2.8125rem]"
                      />
                      <Image
                        src={`https:${file.url}`}
                        alt={description ?? 'Star for Greenlight rating'}
                        width={45}
                        height={45}
                        sizes="(min-width: 720px) 45px, 35px"
                        className="m-1 inline-block w-[2.1875rem] tablet:m-2 tablet:w-[2.8125rem]"
                      />
                      <Image
                        src={`https:${file.url}`}
                        alt={description ?? 'Star for Greenlight rating'}
                        width={45}
                        height={45}
                        sizes="(min-width: 720px) 45px, 35px"
                        className="m-1 inline-block w-[2.1875rem] tablet:m-2 tablet:w-[2.8125rem]"
                      />
                    </>
                  )}
                  {psFile?.url && (
                    <Image
                      src={`https:${psFile.url}`}
                      alt={psDescription ?? 'Half star for Greenlight rating'}
                      width={45}
                      height={45}
                      sizes="(min-width: 720px) 45px, 35px"
                      className="m-1 inline-block w-[2.1875rem] tablet:m-2 tablet:w-[2.8125rem]"
                    />
                  )}
                </div>
                <h2
                  className="social-proof-heading"
                  data-testid="componentHeader"
                >
                  {headingText}
                </h2>
                <div className="social-proof-body">
                  {bodyCopy && (
                    <div className="social-proof-text">
                      <RichText
                        data-testid="bodyCopy"
                        colour="defaultText"
                        data={bodyCopy}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
}
